import { get, post } from "@/api/Axios";

// 授权链接
export const wechatLogin = param => {
  const url = "/wechatLogin/loginInit";
  return get(url, param);
};

// 获取token 登录
export const wechatLogin2 = param => {
  const url = "/wechatLogin/getWechatAccessTokenByCode";
  return post(url, param);
};

// 修改报名信息
export const editApplyInfo = param => {
  const url = "/wechatLogin/editApplyInfo";
  return post(url, param);
};

// 获取报名信息
export const getApplyInfo = param => {
  const url = "/wechatLogin/getApplyInfo";
  return post(url, param);
};

// 获取直播任务
export const getLiveList = param => {
  const url = "/wechatMedia/listMediaTask";
  return post(url, param);
};

// 添加查看直播记录
export const addCheckRecord = param => {
  const url = "wechatMedia/addMediaLog";
  return post(url, param);
};
